// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__HYN3c","raised":"panel_raised__BM-yv","skinny":"panel_skinny__5ik-J","none":"panel_none__dYrOV","panelRow":"panel_panelRow__sRnnM"};